import type { ReactElement } from 'react';
import HtmlFragment from '@/components/html-fragment';
import ReactFragment, { isReactContent } from '@/components/react-fragment';

export interface ContentMarkupProps {
    /** HTML or CMS-exported markup (plain HTML or react_components wrapper). */
    content: string;
    /** Optional CSS class applied to the fragment wrapper. */
    className?: string;
}

/**
 * Renders CMS content asset markup with the correct fragment strategy.
 * React exports (PascalCase components, react_components wrapper) use ReactFragment;
 * plain HTML uses HtmlFragment.
 */
export default function ContentMarkup({ content, className }: ContentMarkupProps): ReactElement | null {
    if (!content?.trim()) {
        return null;
    }

    if (isReactContent(content)) {
        return <ReactFragment content={content} className={className} />;
    }

    return <HtmlFragment content={content} className={className} />;
}
